module.exports = __webpack_public_path__ + "media/Loops 110 Bass.8f5b8928.wav";